function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n\n    ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n\n      &:hover,\n      &.focus {\n        border-color: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border: 2px solid ", ";\n    border-radius: 10px;\n    box-sizing: content-box;\n    height: auto;\n    padding: 0;  \n    \n    ", " {\n      margin-left: ", ";\n      fill: ", ";\n    }\n\n    ", " {\n      margin-right: ", ";\n      fill: ", ";\n    }\n\n    &:hover,\n    &.focus {\n      border-color: ", ";\n    }\n\n    ", "\n\n    ", " {\n      border-radius: 10px;\n      box-shadow: none;\n      filter: none;\n      height: ", ";\n      max-width: 100%;\n      padding: 0 ", ";\n\n      &:-webkit-autofill-selected {\n        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),\n          inset 0 0 0 100px ", ";\n      }\n\n      &:-webkit-autofill {\n        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),\n          inset 0 0 0 100px ", ";\n        z-index: 1;\n      }\n\n      &:-webkit-autofill:hover {\n        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),\n          inset 0 0 0 100px ", ";\n        z-index: 1;\n      }\n\n      &:-webkit-autofill:focus {\n        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),\n          inset 0 0 0 100px ", ";\n        z-index: 1;\n      }\n\n      ", "\n\n      ", "\n    }\n\n    ", " {\n      padding: 0 !important;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from "react";
import styled, { css } from "styled-components";
import { TextInput as BaseTextInput, TextInputStyles } from "@diana-ui/textinput";
var StyledTextInput = styled(BaseTextInput)((_ref) => {
  var {
    disabled,
    theme
  } = _ref;
  return css(_templateObject(), theme.colors.grey.grey100, TextInputStyles.PrefixIcon, theme.spaceUnit.sm, theme.colors.grey.grey100, TextInputStyles.SuffixIcon, theme.spaceUnit.sm, theme.colors.grey.grey100, theme.colors.black, disabled && css(_templateObject2(), theme.colors.white, theme.colors.grey.grey100), TextInputStyles.Input, theme.spaceUnit.xl, theme.spaceUnit.xs, theme.colors.white, theme.colors.white, theme.colors.white, theme.colors.white, disabled && css(_templateObject3(), theme.colors.white, theme.colors.grey.grey100), theme.typography.detailText, TextInputStyles.Legend);
});
var Wrapper = styled.div(_templateObject4());
var Label = styled.span((_ref2) => {
  var {
    theme
  } = _ref2;
  return css(_templateObject5(), theme.spaceUnit.xs, theme.typography.detailText);
});
export var TextInputWrapper = (_ref3) => {
  var {
    children,
    label
  } = _ref3;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Label, null, label), children);
};

var TextInput = (_ref4) => {
  var {
    label,
    ref
  } = _ref4,
      props = _objectWithoutProperties(_ref4, ["label", "ref"]);

  return label ? /*#__PURE__*/React.createElement(TextInputWrapper, {
    label: label
  }, /*#__PURE__*/React.createElement(StyledTextInput, props)) : /*#__PURE__*/React.createElement(StyledTextInput, props);
};

export default TextInput;